export default __webpack_public_path__ + "warning-icon-medium.svg";